import { render, staticRenderFns } from "./Pravila.vue?vue&type=template&id=17646061&scoped=true&"
import script from "./Pravila.vue?vue&type=script&lang=js&"
export * from "./Pravila.vue?vue&type=script&lang=js&"
import style0 from "./Pravila.vue?vue&type=style&index=0&id=17646061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17646061",
  null
  
)

export default component.exports